var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "py-4" }, [
    _c(
      "div",
      {
        staticClass:
          "inline-flex text-gray-500 hover:text-brandRed cursor-pointer",
        on: {
          click: function() {
            return _vm.$emit("close")
          }
        }
      },
      [
        _c("chevron-left", { staticClass: "w-6 h-6" }),
        _vm._v(" "),
        _c("p", [_vm._v("Objednávka číslo " + _vm._s(_vm.order.number))])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", [
      _c("dl", { staticClass: "divide-y divide-gray-200" }, [
        _c("div", { staticClass: "grid grid-cols-3 py-4" }, [
          _c("dt", { staticClass: "text-gray-500" }, [
            _vm._v("Datum objednání")
          ]),
          _vm._v(" "),
          _c("dd", [_vm._v(_vm._s(_vm.date))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid grid-cols-3 py-4" }, [
          _c("dt", { staticClass: "text-gray-500" }, [_vm._v("Stav")]),
          _vm._v(" "),
          _c(
            "dd",
            [_c("order-status", { attrs: { slug: _vm.order.status } })],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid grid-cols-3 py-4" }, [
          _c("dt", { staticClass: "text-gray-500" }, [
            _vm._v("Nejdřívější datum odeslání")
          ]),
          _vm._v(" "),
          _c("dd", [
            _vm._v("\n          " + _vm._s(_vm.sentDate) + "\n        ")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid grid-cols-3 py-4" }, [
          _c("dt", { staticClass: "text-gray-500" }, [_vm._v("Cena")]),
          _vm._v(" "),
          _c("dd", [_vm._v("\n          " + _vm._s(_vm.total) + "\n        ")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid grid-cols-3 py-4" }, [
          _c("dt", { staticClass: "text-gray-500" }, [_vm._v("Produkty")]),
          _vm._v(" "),
          _c(
            "dd",
            { staticClass: "col-span-2" },
            _vm._l(_vm.products, function(product) {
              return _c(
                "div",
                { key: product.id, staticClass: "grid grid-cols-2" },
                [
                  _c("p", [
                    _vm._v(
                      "\n              " +
                        _vm._s(product.quantity) +
                        "x\n              "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "hover:text-brandRed",
                        attrs: { href: product.permalink, target: "_blank" }
                      },
                      [_vm._v(_vm._s(product.name))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(_vm._s(_vm.priceFormatter.format(product.total)))
                  ])
                ]
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid grid-cols-3 py-4" }, [
          _c("dt", { staticClass: "text-gray-500" }, [_vm._v("Doprava")]),
          _vm._v(" "),
          _c("dd", { staticClass: "col-span-2" }, [
            _c("div", { staticClass: "grid grid-cols-2" }, [
              _c("p", [_vm._v(_vm._s(_vm.order.shipping_method.name))]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.priceFormatter.format(_vm.order.shipping_total))
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid grid-cols-3 py-4" }, [
          _c("dt", { staticClass: "text-gray-500" }, [
            _vm._v("Fakturační údaje")
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("p", [
              _vm._v(
                _vm._s(_vm.order.billing.first_name) +
                  " " +
                  _vm._s(_vm.order.billing.last_name)
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.order.billing.phone))]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.order.billing.address_1) +
                  ", " +
                  _vm._s(_vm.order.billing.postcode) +
                  "\n            " +
                  _vm._s(_vm.order.billing.city) +
                  "\n          "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid grid-cols-3 py-4" }, [
          _c("dt", { staticClass: "text-gray-500" }, [
            _vm._v("Doručovací údaje")
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("p", [_vm._v(_vm._s(_vm.order.shipping_method.name))]),
            _vm._v(" "),
            _vm.order.shipping_method.id === "packeta"
              ? _c("div", [
                  _c("p", [
                    _vm._v(_vm._s(_vm.order.shipping_method.packeta.name))
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.order.shipping_method.packeta.street) +
                        ",\n              " +
                        _vm._s(_vm.order.shipping_method.packeta.postcode) +
                        "\n              " +
                        _vm._s(_vm.order.shipping_method.packeta.city) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "text-brandRed",
                      attrs: {
                        href: _vm.order.shipping_method.packeta.url,
                        target: "_blank"
                      }
                    },
                    [_vm._v("Detail pobočky")]
                  )
                ])
              : _vm.order.shipping_method.id !== "local_pickup" &&
                _vm.order.shipping_method.id !== "packeta"
              ? _c("div", [
                  _c("p", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.order.shipping.first_name) +
                        " " +
                        _vm._s(_vm.order.shipping.last_name) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.order.shipping.phone))]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.order.shipping.address_1) +
                        ", " +
                        _vm._s(_vm.order.shipping.postcode) +
                        "\n              " +
                        _vm._s(_vm.order.shipping.city) +
                        "\n            "
                    )
                  ])
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "max-w-xs" }, [
        _c(
          "button",
          {
            staticClass:
              "px-12 py-2 text-white bg-almostBlack hover:bg-black rounded-full focus:outline-none w-full relative",
            attrs: { disabled: _vm.loading, type: "submit" },
            on: { click: _vm.cancelOrder }
          },
          [
            _c("span", { class: { "opacity-0": _vm.loading } }, [
              _vm._v("Zrušit objednávku")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "absolute flex space-x-4 transform -translate-x-1/2 -translate-y-1/2 loading top-1/2 left-1/2",
                class: { "opacity-0": !_vm.loading }
              },
              [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "animate-pulse" }, [
      _c("div", { staticClass: "w-3 h-3 bg-white rounded-full animate-bounce" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "animate-pulse" }, [
      _c("div", { staticClass: "w-3 h-3 bg-white rounded-full animate-bounce" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "animate-pulse" }, [
      _c("div", { staticClass: "w-3 h-3 bg-white rounded-full animate-bounce" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib?{}!./scripts/vue/auth/partials/OrderDetail.vue?vue&type=template&id=8402c976&
// module id = 183
// module chunks = 0